export enum SessionGetParams {
    SessionData = 'sdata',
    DecryptionKey = 'skey'
}